import { useCallback, useMemo } from 'react'
import { useAserto as useAsertoSdk } from '@aserto/aserto-react'
import { useIdentity } from '@aserto/console-common'

import { useConfig } from '../services/ConfigProvider'

export function useAserto() {
  const { getAccessToken } = useIdentity()
  const { init, reload } = useAsertoSdk()
  const { backendServiceUrl } = useConfig()

  const callInit = useCallback(
    async (tenantId: string): Promise<void> => {
      // aserto-sdk expects the token without `Bearer`
      const token = (await getAccessToken()).replace('Bearer ', '')
      const options = {
        serviceUrl: backendServiceUrl,
        accessToken: token,
        throwOnError: true,
      }
      const body = JSON.stringify({ 'Aserto-Tenant-Id': tenantId })
      await init(options, body)
    },
    [getAccessToken, backendServiceUrl, init]
  )

  const callReload = useCallback(
    async (tenantId: string): Promise<void> => {
      const body = JSON.stringify({ 'Aserto-Tenant-Id': tenantId })
      await reload(body)
    },
    [reload]
  )

  return useMemo(
    () => ({
      init: callInit,
      reload: callReload,
    }),
    [callInit, callReload]
  )
}
